import React from 'react';
import axios from 'axios';
import * as utils from '../../utils';
import * as apis from '../../constants/Apis';
import Layout from '../../components/Layout';  
import Portlet from '../../components/Portlet';
import DataTable from '../../components/DataTable';
import LoadingPage from '../../components/Layout/LoadingPage'; 
import {ToastContainer} from 'react-toastr';
import '../../assets/css/toastr.css';

class UserProfile extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            id: "",
            meta: {},
            paramsFilter: "[]",
            showLoading: false,
            profile: {},
            data: [],
            total: 0
        }        
    }

    componentDidMount(){
        let {t, match} = this.props;
        let _this = this
        if(match.hasOwnProperty("params") && match.params.hasOwnProperty("id")){
            this.setState({showLoading: true})
            let {id} = match.params
            axios.get(apis.BASE_URL + 'users/' + id + '/detail', utils.getConfig())
            .then( res => {
                let total = res.data.items.hasOwnProperty("info") && res.data.items.info.hasOwnProperty("_meta") && res.data.items.info._meta.hasOwnProperty("totalCount") && res.data.items.info._meta.totalCount
                _this.setState({
                    id: id,
                    showLoading : false,
                    meta: res.data.items.hasOwnProperty("info") ? res.data.items.info._meta : {},
                    data: res.data.items.hasOwnProperty("data") ? res.data.items.data : {},
                    profile: res.data.items.hasOwnProperty("profile") ? res.data.items.profile : {},
                    total: total
                })
            })
            .catch( error => {
                _this.setState({showLoading: false});
                _this.refs.toastContainer.error(t("Cannot get user detail"));
            });
        }

    }

    changeMeta(meta, filter = false){
        const {t} = this.props
        let {id} = this.state
        let _this= this

        this.setState({showLoading: true})
        //define str to handle api
        filter = filter !== "" ? `["and",${filter},{"e_user__id":"${id}"}]` : `{"e_user__id":"${id}"}`
        let sort = meta.sortInfo ? '{"'+meta.sortInfo.property+'":"SORT_'+meta.sortInfo.direction+'"}' : '{"created_at":"SORT_DESC"}'
        let str = 'projects/list/'+meta.currentPage+'/'+meta.perPage+'/'+sort+'/'+filter
        axios.get(apis.BASE_URL + str, utils.getConfig())
        .then( res => {
            _this.setState({
                showLoading : false,
                meta: res.data._meta,
                data: res.data.items
            })
        })
        .catch( error => {
            _this.setState({showLoading : false});
            _this.refs.toastContainer.error(t("Cannot get user detail"));
        });
    }

    render(){
        const {t} = this.props
        let {showLoading, profile, data, meta, total} = this.state
        let config = {
            api: true,
            filter:true,
            cols: [
                { property: "proj_name", header: t("Project URL"), sortable: true,
                    filterType: {type: "text"},
                    decorator : () => ({ style : { width : "40%" } }),
                    renderer : value =>  value ? (<a href={"https://" + value + ".rtsurvey.com"} target="_blank" rel="noopener noreferrer">https://{value}.rtsurvey.com</a>) : ""
                },
                { property: "status", header: t("Status"), sortable: true,
                    filterType: {type: "number", prefix:"e_user_project__", values: [{label: t("Select all")+"...", value: ""},
                                                        {label: t("Deploy Fail"), value: "-2"},
                                                        {label: t("Inactive"), value: "-1"},
                                                        {label: t("Pause"), value: "0"},
                                                        {label: t("Active"), value: "1"},
                                                        {label: t("In Transaction"), value: "2"},
                                                        {label: t("Paid"), value: "3"},
                                                        {label: t("Deploying"), value: "4"},
                                                        {label: t("Unpaid"), value: "5"},
                                                        {label: t("Verifying Payment"), value: "6"},
                                                        {label: t("Verify Fail"), value: "8"}]},

                    decorator : () => ({ style : {width : "30%",minWidth: "60px"}}),
                    renderer : value => {
                        let className = utils.projectStatusClassName[value]
                        let text = utils.projectStatusText[value]
                        return (<span className={className}>{t(text)}</span>)
                    }
                },
                { property: "created_at", header: t("Created At"), sortable: true,
                    filterType: {type: "date", prefix:"e_user_project__"},
                    decorator : () => ({ style : { width : "30%", minWidth: "75px"} }),
                    renderer : value => utils.convertTimestampToDate(value)
                }
            ]
        }  

        return(
            <Layout>  
                {showLoading && <LoadingPage />}
                    <div className="m-subheader ">
                        <div className="d-flex align-items-center">
                            <div className="mr-auto">
                                <h3 className="m-subheader__title">{t("User Profile")}</h3>
                            </div>
                        </div>
                    </div>
                <Layout.Content>
                    <div className="row">
                        <div className="col-xl-3 col-lg-4">
                            <div className="m-portlet m-portlet--full-height">
                                <div className="m-portlet__body">
                                    <div className="m-card-profile">
                                        <div className="m-card-profile__pic">
                                            <div className="m-card-profile__pic-wrapper">
                                                <img src="/assets/img/users/user.jpg" alt="" />
                                            </div>
                                        </div>
                                        <div className="m-card-profile__details">
                                            <span className="m-card-profile__name">{(profile.hasOwnProperty("firstName") ? profile.firstName : "") + " " + (profile.hasOwnProperty("lastName") ? profile.lastName : "")}</span>
                                            <a href={`mailto:${profile.email}`} className="m-card-profile__email m-link">{profile.email}</a>
                                        </div>
                                    </div>
                                    <ul className="m-nav m-nav--hover-bg m-portlet-fit--sides">
                                        <li className="m-nav__separator m-nav__separator--fit"></li>
                                        <li className="m-nav__item">
                                            <span className="m-nav__link">
                                                <i className="m-nav__link-icon flaticon-profile-1"></i>
                                                <span className="m-nav__link-text">{t('Phone Number')}: {profile.phone}</span>
                                            </span>
                                        </li>
                                        <li className="m-nav__item">
                                            <span className="m-nav__link">
                                                <i className="m-nav__link-icon flaticon-share"></i>
                                                <span className="m-nav__link-text">{t('Address')}: {profile.address}</span>
                                            </span>
                                        </li>
                                        <li className="m-nav__item">
                                            <span className="m-nav__link">
                                                <i className="m-nav__link-icon flaticon-chat-1"></i>
                                                <span className="m-nav__link-text">{t('City')}: {profile.city}</span>
                                            </span>
                                        </li>
                                        <li className="m-nav__item">
                                            <span className="m-nav__link">
                                                <i className="m-nav__link-icon flaticon-chat-1"></i>
                                                <span className="m-nav__link-text">{t('Country')}: {profile.country}</span>
                                            </span>
                                        </li>
                                        <li className="m-nav__item">
                                            <span className="m-nav__link">
                                                <i className="m-nav__link-icon flaticon-chat-1"></i>
                                                <span className="m-nav__link-text">{t('Company')}: {profile.company}</span>
                                            </span>
                                        </li>
                                    </ul>
                                    <div className="m-portlet__body-separator"></div>
                                    <div className="m-widget1 m-widget1--paddingless">
                                        <div className="m-widget1__item">
                                            <div className="row m-row--no-padding align-items-center">
                                                <div className="col">
                                                    <h3 className="m-widget1__title">{t('Project')}</h3>
                                                </div>
                                                <div className="col m--align-right">
                                                    <span className="m-widget1__number m--font-brand">{total}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="m-widget1__item">
                                            <div className="row m-row--no-padding align-items-center">
                                                <div className="col">
                                                    <h3 className="m-widget1__title">{t('Balance')}</h3>
                                                </div>
                                                <div className="col m--align-right">
                                                {
                                                    profile.accountBalance > 0 ?
                                                    <span className="m-widget1__number m--font-danger">- ${profile.accountBalance}</span> :
                                                    <span className="m-widget1__number m--font-success">${Math.abs(profile.accountBalance)}</span>
                                                }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-9 col-lg-8">
                            <Portlet >
                                <Portlet.Title>
                                    <Portlet.Caption>
                                        <h3 className="m-portlet__head-text">{t('Project List')}</h3>
                                    </Portlet.Caption>
                                </Portlet.Title>
                                <Portlet.Body>
                                    <DataTable t={t} className="margin-top--60" datasource={data} config={config} meta={meta} changeMeta={this.changeMeta.bind(this)}/>
                                </Portlet.Body>
                            </Portlet>
                        </div>
                    </div>
                </Layout.Content>
                <ToastContainer 
                    ref="toastContainer"
                    className="toast-top-right"
                />
            </Layout>
        );
    }
}

export default UserProfile;
